import { render, staticRenderFns } from "./allDeviceDetail.vue?vue&type=template&id=442b28a6&scoped=true&"
import script from "./allDeviceDetail.vue?vue&type=script&lang=js&"
export * from "./allDeviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./allDeviceDetail.vue?vue&type=style&index=0&id=442b28a6&scoped=true&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b28a6",
  null
  
)

export default component.exports